import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material';
import { Router, ActivatedRoute, Params } from '@angular/router';

import * as TerceroFormModel from './Tercero.model';
import { OpcionModel } from '../Global/Opcion.model';
import { ServiciosGenerales } from '../Servicios/ServiciosGenerales.service';
import { timeout } from 'rxjs/operator/timeout';
import { delay } from 'rxjs/operator/delay';


@Component({
	selector: 'TerceroForm',
	templateUrl: './TerceroForm.component.html'
})


export class TerceroFormComponent {
	// ~~~~~ Variables para el manejo de permisos ~~~~~ //
	public btnAgregar: boolean;
	public btnEditar: boolean;
	public btnEliminar: boolean;
	public btnConsultar: boolean;
	// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~ //

	public form: FormGroup;
	public formErrors: any;

	public tercero: TerceroFormModel.TerceroModel;
	public tiposId: Array<OpcionModel>;
	public tiposPersonas: Array<OpcionModel>;
	public tiposContribuyente: Array<OpcionModel>;
	public tiposTributo: Array<OpcionModel>;
	public listaNegocios: Array<OpcionModel>;

	public cargando: boolean;
	public guardando: boolean;
	public registroTercero;
	public mensaje: string;
	public cantidadSucursales;
	public creaSucursal: boolean;
	public responsabilidadesFiscales = new Array();

	public ocultar: boolean = false;




	constructor(private formBuilder: FormBuilder,
		private _serviciosGenerales: ServiciosGenerales,
		private snackBar: MatSnackBar,
		private _route: ActivatedRoute,
		private _router: Router) {

		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.btnAgregar = _serviciosGenerales.seguridad.isAgregar();
		this.btnEditar = _serviciosGenerales.seguridad.isEditar();
		this.btnEliminar = _serviciosGenerales.seguridad.isEliminar();
		this.btnConsultar = _serviciosGenerales.seguridad.isConsultar();
		// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~//
		this.snackBar.dismiss();
		this.formErrors = {

			tipoId: {},
			numId: {},
			nombre: {},
			tipoPersona: {},
			tipoContribuyente: {},
			tipoTributo: {},
			responsibilidades: {}
		};

		this.tiposId = new Array();
		this.tiposPersonas = new Array();
		this.tiposContribuyente = new Array();
		this.listaNegocios = new Array();
		this.tiposTributo = new Array();


		this.tercero = new TerceroFormModel.TerceroModel(new TerceroFormModel.DefTiposdocumentos(''),
			new TerceroFormModel.MchTercerosId('', '', '', 0),
			0, '', '', '', 0, 0, new TerceroFormModel.DefTipospersona(''),
			/*new TerceroFormModel.ParamNegocios(new TerceroFormModel.ParamNegociosId("", 0)),*/
			new TerceroFormModel.DefContribuyentes(''), '', '');

		this.cargando = false;
		this.guardando = false;

	}

	ngOnInit() {

		/*Se carga la informacion de las listas*/
		this.cargarInfo();

		/*Se obtiene la informacion que viaja por parametros para cargar el tercero*/
		this._route.params.subscribe(params => {
			this.registroTercero = [{
				'cnumcont': params['cnumcont'],
				'ctipid': params['ctipid'],
				'cnumid': params['cnumid']
			}];
		}
		)


		if (this.registroTercero[0].ctipid != ' ' && this.registroTercero[0].cnumid != ' ') {
			this.cargarListaTerceros();
			this.mensaje = "Editar";
			this.creaSucursal = false;
		} else {
			this.mensaje = "Crear";
			this.tercero.id.cnumcont = this.registroTercero[0].cnumcont;
			this.creaSucursal = true;
		}


		this.inicializarForm();
		this.form.valueChanges.subscribe(() => {
			this.onFormValuesChanged();
		});

	}


	inicializarForm() {
		this.form = this.formBuilder.group({

			tipoId: [{ disabled: true, value: this.tercero.id.ctipid }, Validators.required],
			numId: [{ disabled: true, value: this.tercero.id.cnumid }, Validators.required],
			nombre: ['', Validators.required],
			tipoPersona: ['', Validators.required],
			tipoContribuyente: ['', Validators.required],
			responsibilidades: ['', Validators.required],
			tipoTributo: ['', Validators.required]
		});
	}


	cargarInfo() {

		

		this._serviciosGenerales.get('responsabilidadesTributarias', { param: 0 }).subscribe(
		   result => {
			   for (let x of result){
				   this.responsabilidadesFiscales.push(x.codigo);
			   }
		   },
		   error => {
			   var errorMensaje = <any>error;
			   console.log('Error al enviar la peticion ', errorMensaje);
			   this.openSnackBarEspecial("Ocurrió un error al momento de cargar las Responsabilidades Tributarias", "X");
		   }
	   );


		this._serviciosGenerales.get('listaNegocios', { param: 0 }).subscribe(result => {
			for (let x of result)
				this.listaNegocios.push(new OpcionModel(x.cnumcont, x.cnumcont));

		},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los patrimonios", "X");

			});

		this._serviciosGenerales.get('tipoIdentificacion', { param: 0 }).subscribe(result => {
			for (let x of result)
				this.tiposId.push(new OpcionModel(x.ctipid, x.vdescripcion));

		},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de identificación", "X");

			});

		this._serviciosGenerales.get('tipoPersona', { param: 0 }).subscribe(result => {
			for (let x of result)
				this.tiposPersonas.push(new OpcionModel(x.ntipper, x.vdescripcion));

		},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de persona", "X");

			});

		this._serviciosGenerales.get('tiposContribuyente', { param: 0 }).subscribe(result => {
			for (let x of result)
				this.tiposContribuyente.push(new OpcionModel(x.nidcontribuyente, x.vdescripcion));

		},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");

			});


		this._serviciosGenerales.get('codigoTributo', { param: 0 }).subscribe(result => {
			for (let x of result) {
				this.tiposTributo.push(new OpcionModel(x.vcodigotri, x.vdescrip));
				console.log(x);
			}

		},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de cargar los tipos de contribuyente", "X");

			});


	}




	private cargarListaTerceros() {


		this.tercero = new TerceroFormModel.TerceroModel(new TerceroFormModel.DefTiposdocumentos(''),
			new TerceroFormModel.MchTercerosId('', '', '', 0),
			0, '', '', '', 0, 0, new TerceroFormModel.DefTipospersona(''),
			/*new TerceroFormModel.ParamNegocios(new TerceroFormModel.ParamNegociosId('', 0)),*/
			new TerceroFormModel.DefContribuyentes(''), '', '');


		this._serviciosGenerales.get('terceros',
			{ cnumcont: this.registroTercero[0].cnumcont, ctipid: this.registroTercero[0].ctipid, cnumid: this.registroTercero[0].cnumid }).subscribe(result => {

				for (let x of result) {

					this.tercero = (new TerceroFormModel.TerceroModel(new TerceroFormModel.DefTiposdocumentos(x.ctipid),
						new TerceroFormModel.MchTercerosId(x.cnumid, x.cnumcont, x.ctipid, x.ntipoempresa),
						x.ndigchk, x.vnombre, x.vapellido, x.vapellido2, x.nestado, 0, new TerceroFormModel.DefTipospersona(x.ntipper),
						/*new TerceroFormModel.ParamNegocios(new TerceroFormModel.ParamNegociosId(x.cnumcont, x.ntipoempresa)),*/
						new TerceroFormModel.DefContribuyentes(x.nidcontribuyente), x.vcodigotri, x.vresponfis)
					);
					console.log(this.tercero);
				}

			},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar el tercero", "X");
				});


		this._serviciosGenerales.get('cantidadSucursales',
			{ cnumcont: this.registroTercero[0].cnumcont, ctipid: this.registroTercero[0].ctipid, cnumid: this.registroTercero[0].cnumid }).subscribe(result => {

				for (let x of result) {
					this.cantidadSucursales = x.cantidad;
				}

			},
				error => {
					var errorMensaje = <any>error;
					console.log('Error al enviar la peticion ', errorMensaje);
					this.openSnackBarEspecial("Ocurrió un error al momento de cargar el tercero", "X");
				});

	}

	openSnackBar(message: string, action: string) {
		this.snackBar.open(message, action, {
			duration: 20000
		});
	}


	onFormValuesChanged() {
		for (const field in this.formErrors) {
			if (!this.formErrors.hasOwnProperty(field)) {
				continue;
			}

			// Clear previous errors
			this.formErrors[field] = {};

			// Get the control
			const control = this.form.get(field);

			if (control && control.dirty && !control.valid) {
				this.formErrors[field] = control.errors;
			}
		}
	}


	guardar() {
		var responFiscal = this.tercero.vresponfis.split(";");

		for (var c of responFiscal) {
			var resultado = this.responsabilidadesFiscales.find(function (x) {
				return x === c;
			});
			
			if(resultado == undefined){
				this.openSnackBarEspecial('El código  de Responsabilidad Fiscal : ' + c + ' No está definido  ', 'X');
				return;
			}
		}
		
		if (this.form.valid == false) {
			this.openSnackBarEspecial('Hay Campos requeridos sin llenar', 'X');
			return;
		}

		if (this.tercero.defTiposdocumentos.ctipid != '02' && this.tercero.defTiposdocumentos.ctipid != '07' && this.tercero.defTiposdocumentos.ctipid != '08') {
			if (this.tercero.vapellido.trim() == '') {
				this.openSnackBarEspecial('El primer apellido es requerido', 'X');
				return;
			}
		}

		if (this.tercero.defContribuyentes.nidcontribuyente == undefined)
			this.tercero.defContribuyentes.nidcontribuyente = '';


		if (String(this.tercero.defContribuyentes.nidcontribuyente).trim() == '') {
			this.tercero.defContribuyentes.nidcontribuyente = '8';
		}





		this.guardando = true;
		//this.tercero.paramNegocios.id.cnumcont = this.tercero.id.cnumcont;
		this.tercero.id.ctipid = this.tercero.defTiposdocumentos.ctipid;

		this.tercero.nestado = (this.tercero.nestado == true ? 1 : 0);

		this._serviciosGenerales.post('guardar/tercero', this.tercero).subscribe(
			result => {
				this.openSnackBar("Proceso realizado con éxito", "X");


				this.form.reset();
				this.form.clearAsyncValidators();
				this.form.clearValidators();

				if (this.creaSucursal == true) {


					this._router.navigate(['/Sucursal',
						this.tercero.id.cnumcont,
						this.tercero.id.ctipid,
						this.tercero.id.cnumid,
						this.tercero.vnombre,
						' ',
						' ',
						'insertar']);
				}

				this.tercero = new TerceroFormModel.TerceroModel(new TerceroFormModel.DefTiposdocumentos(''),
					new TerceroFormModel.MchTercerosId('', '', '', 0),
					0, '', '', '', 0, 0, new TerceroFormModel.DefTipospersona(''),
					/*new TerceroFormModel.ParamNegocios(new TerceroFormModel.ParamNegociosId('', 0)),*/
					new TerceroFormModel.DefContribuyentes(''), '', '');
				this.guardando = false;
				this.cargarListaTerceros();
			},
			error => {
				var errorMensaje = <any>error;
				console.log('Error al enviar la peticion ', errorMensaje);
				this.openSnackBarEspecial("Ocurrió un error al momento de guardar el tercero", "X");
			}

		)


	}

	verSucursales() {
		this._router.navigate(['/Sucursal',
			this.registroTercero[0].cnumcont,
			this.registroTercero[0].ctipid,
			this.registroTercero[0].cnumid,
			this.tercero.vnombre, 'form']);
	}

	validarRequerido() {

	}

	openSnackBarEspecial(message: string, action: string) {
		let snackBarRef =  this.snackBar.open(message, action);

		snackBarRef.onAction().subscribe(() => {
			console.log("Paso por aqui 1 notas");

			this.ocultar = false;
			this.mensaje = "";
		});
		
		let shand = document.getElementsByClassName('mat-snack-bar-container') as HTMLCollectionOf<HTMLElement>;		
		
		if (shand.length != 0) {
			    for (let i=0;i<shand.length;i++){
				shand[i].style.backgroundColor = "rgb(255 204 214)";
				}
			}
	}


}


// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/Tercero/TerceroForm.component.ts